<template>
  <ol class="row workflow-steps">
    <li v-for="item in items" :key="item.id" class="col-lg-6 col-md-12 mb-25 workflow-step">
      <article class="workflow-step-card">
        <div class="workflow-step-number" aria-hidden="true">{{ item.id }}</div>
        <div class="workflow-step-content">
          <p class="workflow-step-owner">{{ item.owner }}</p>
          <h3 class="heading">{{ item.heading }}</h3>
          <p class="workflow-step-text">{{ item.text }}</p>
        </div>
      </article>
    </li>
  </ol>
</template>

<script>
export default {
  name: "PaymentFeature",
  data() {
    return {
      items: [
        {
          id: 1,
          owner: "In After Effects",
          heading: "Create a MOGRT file",
          text: "Add the editable controls to Essential Graphics and export the MOGRT from After Effects.",
        },
        {
          id: 2,
          owner: "In the desktop app",
          heading: "Sync a reusable template",
          text: "Place the MOGRTs in a named sync-folder template. MoDeck publishes their controls online.",
        },
        {
          id: 3,
          owner: "In the browser",
          heading: "Let teammates make the versions",
          text: "Invite editors to change content by hand or generate a batch from data.",
        },
        {
          id: 4,
          owner: "Back on your machine",
          heading: "Render, deliver, or finish by hand",
          text: "The desktop app assembles the edit in After Effects, renders it, and can return the finished file.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.workflow-steps {
  padding-left: 0;
  margin-bottom: -25px;
  list-style: none;
}

.workflow-step-card {
  display: flex;
  height: 100%;
  padding: 34px;
  border: 1px solid #e5eaf1;
  border-radius: 10px;
  background: #ffffff;
}

.workflow-step-number {
  display: flex;
  flex: 0 0 48px;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-right: 22px;
  border-radius: 50%;
  background: #364563;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
}

.workflow-step-owner {
  margin-bottom: 8px;
  color: #d9317c;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.workflow-step-content .heading {
  margin-bottom: 12px;
  color: #364563;
  font-size: 21px;
  font-weight: 500;
  line-height: 1.4;
}

.workflow-step-text {
  margin-bottom: 0;
  line-height: 1.8;
}

@media (max-width: 575px) {
  .workflow-step-card {
    display: block;
    padding: 28px 24px;
  }

  .workflow-step-number {
    margin: 0 0 20px;
  }
}
</style>
